export default __webpack_public_path__ + "static/dether-545fb004820e930e0e17064032511552.jpg";